module.exports = __webpack_public_path__ + "media/recipes/34-16ea52e1.png";